import React, { Fragment } from 'react'
import { Col, Divider, Input, Row } from 'antd'
import FormItem from 'Components/FormItem'
import { numeral } from 'Common/global'
import { formats, userType } from 'Common/constants'
import styled from 'styled-components'

export default class EditRowModalAgreement extends React.Component {
  constructor(props) {
    super(props);
    this.percent = React.createRef();
    this.price = React.createRef();
  }

  percentageChanged() {
    let priceInput;
    if( this.props.user.type === userType.PM.key || this.props.user.type === userType.AM.key) {
      priceInput = document.getElementById('proposedPriceField')
    } else {
      priceInput = document.getElementById('acceptedPriceField')
    }
    //const priceInput = document.getElementById('proposedPriceField')
    const percentInput = document.getElementById('discountField')
    const basePrice = this.props.row.price
    priceInput.value = basePrice - (basePrice * percentInput.value/100)
  }

  priceChanged() {
    const percentInput = document.getElementById('discountField')
    if(percentInput) {
      percentInput.value = ''
    }
  }

  getStoreNameFromId(storeId) {
    const { stores } = this.props;

    return Array.isArray(stores) ? stores.find(item => item.storeCode === storeId).storeDesc : null;
  }

  render() {
    const props = this.props
    // const applyDiscount = (e, field) =>
    //   // Change price when discount is applied
    //   (document.getElementById(field).value = (
    //     props.row.price -
    //     (props.row.price * e.target.value) / 100
    //   ).toFixed(2))

    let InputStyled = styled(Input)`
      &.error-field {
        border: 1px solid #cc3333 !important;
        &:focus {
          box-shadow: 0 0 0 2px rgba(204, 51, 51, 0.2) !important;
        }
      }
    `;

    return (
      <Row gutter={8}>
        <Col span={24}>
          <FormItem label="Referenza">
            {props.row.refLm} - {props.row.description}
          </FormItem>
        </Col>
        <Divider/>
        {props.user.type === userType.PM.key || props.user.type === userType.AM.key ? (
          <Fragment>
            <Col span={6}>
              <FormItem label="Prezzo">{numeral(props.row.price).format(formats.currency)}</FormItem>
            </Col>
            <Col span={9}>
              <FormItem label="% di sconto">
                <Input
                  onChange={() => this.percentageChanged()}
                  defaultValue={props.row.discount}
                  id="discountField"
                />
              </FormItem>
            </Col>
            <Col span={9}>
              <FormItem label="Prezzo proposto">
                <Input
                  onChange={() => this.priceChanged()}
                  defaultValue={props.row.proposedPrice}
                  id="proposedPriceField"
                />
              </FormItem>
            </Col>
            <Divider/>
            <div style={{ maxHeight: '200px', overflow: 'auto' }}>
              {props.row.connections.map(o => {
                return (
                  <Row key={o.storeId}>
                    <Col span={6}>
                      <FormItem label="Id negozio">{o.storeId}</FormItem>
                    </Col>
                    <Col span={6}>
                      <FormItem label="Negozio">{this.getStoreNameFromId(o.storeId)}</FormItem>
                    </Col>
                    <Col span={6}>
                      <FormItem label="Qtà stock">{numeral(o.storeStock).format(formats.number)}</FormItem>
                    </Col>
                    <Col span={6}>
                      <FormItem label="Qtà proposta">
                        <InputStyled
                          id={`QuantityField-${o.storeId}`}
                          defaultValue={o.proposedStock}
                          data-store-id={o.storeId}
                          className="proposedQuantityField"
                        />
                      </FormItem>
                    </Col>
                  </Row>
                )
              })}
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <Col span={6}>
              <FormItem label="Prezzo proposto">
                {numeral(props.row.proposedPrice).format(formats.currency)}
              </FormItem>
            </Col>
            <Col span={9}>
              <FormItem label="% di sconto">
                <Input
                  onChange={() => this.percentageChanged()}
                  defaultValue={props.row.discount}
                  id="discountField"
                />
              </FormItem>
            </Col>
            <Col span={9}>
              <FormItem label="Prezzo accettato">
                <Input
                  onChange={() => this.priceChanged()}
                  defaultValue={props.row.acceptedPrice}
                  id="acceptedPriceField"
                />
              </FormItem>
            </Col>
            <Divider/>
            <div style={{ maxHeight: '200px', overflow: 'auto' }}>
              {props.row.connections.map(o => {
                return (
                  <div key={o.storeId}>
                    <Col span={4}>
                      <FormItem label="Id negozio">{o.storeId}</FormItem>
                    </Col>
                    <Col span={5}>
                      <FormItem label="Negozio">{this.getStoreNameFromId(o.storeId)}</FormItem>
                    </Col>
                    <Col span={5}>
                      <FormItem label="Qtà stock">{numeral(o.storeStock).format(formats.number)}</FormItem>
                    </Col>
                    <Col span={5}>
                      <FormItem label="Qtà proposta">
                        {numeral(o.proposedStock).format(formats.number)}
                      </FormItem>
                    </Col>
                    <Col span={5}>
                      <FormItem label="Qtà accettata">
                        <InputStyled
                          id={`QuantityField-${o.storeId}`}
                          defaultValue={o.acceptedStock}
                          data-store-id={o.storeId}
                          className="acceptedQuantityField"
                        />
                      </FormItem>
                    </Col>
                    <Divider/>
                  </div>
                )
              })}
            </div>
          </Fragment>
        )}
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EditRowModalAgreement/index.js